<template>
  <b-card
    no-body
    class="table-border-container"
  >
    <b-row
      class="mt-2 mb-2"
    >
      <b-col>
        <div class="site-hardware-actions site-hardware-actions_management wifi-setting">
          <div class="wifi-setting-label">
            <p class="label">
              Access points
            </p>
          </div>
          <div
            class="double-button actions-wifi-settings"
          >
            <b-dropdown
              ref="dropdown"
              toggle-class="more-dropdown-transparent"
              dropdown
              right
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="FilterIcon"
                  size="16"
                  class="text-body align-middle"
                  color="#F0554E"
                />
              </template>

              <!-- list of checkboxes to filter columns -->
              <b-dropdown-item
                v-for="(label, field) in fieldLabelsSelected"
                :key="field"
                :disabled="label.label === 'Status' && !!activeTab"
                @click="changeColumns(field)"
              >
                <b-form-checkbox
                  v-model="fieldLabelsSelected[field].selected"
                  :disabled="label.label === 'Status' && !!activeTab"
                  @change="changeColumns(field)"
                >
                  {{ label.label }}
                </b-form-checkbox>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-tabs
      v-model="activeTab"
      card
      pills
      class="site-info-tabs no-margins"
      :class="{'one-tab': newCapsman}"
    >
      <b-tab
        v-if="!newCapsman"
        title="Wi-Fi 5"
        active
      />
      <b-tab
        title="Wi-Fi 6+"
      />
    </b-tabs>
    <table-mobile-solo
      :handle-search="null"
      :items="items"
      :custom-class="'no-padding'"
      :loading="isLoading"
      :fields="fields.filter(field => field.field !== 'is_enabled')"
      :actions="[{
        label: 'Edit',
        type: 'primary',
        icon: 'EditIcon',
        visible: () => true,
        click: (item) => {
          openEditModal(item, true);
        },
      }, {
        label: (item) => item.enabled ? 'Disable' : 'Enable',
        type: 'primary',
        icon: 'EditIcon',
        visible: () => true,
        click: (item) => changeStatus(item),
      }]"
    />
    <b-card-body>
      <vue-good-table
        ref="VueGoodTable"
        :is-loading="isLoading"
        :columns="fields"
        :rows="items"
        mode="remote"
        compact-mode
        :sort-options="{
          enabled: true,
          multipleColumns: true,
          initialSortBy: {field: orderBy, type: sortedBy}
        }"
        class="hide-mobile-table"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
      >
        <template slot="loadingContent">
          <b-spinner
            variant="primary"
            label="Spinning"
          />
        </template>
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'actions'">
            <span class="d-flex justify-content-center">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-b-modal.access-point-modal
                  @click.prevent="openEditModal(props.row)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <span
            v-else-if="props.column.field === 'enabled'"
          >
            <b-form-checkbox
              v-model="props.formattedRow.enabled"
              name="is_enabled"
              switch
              inline
              @change="changeStatus(props.row)"
            />
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

      </vue-good-table>
    </b-card-body>

    <EditModal
      :site-id="siteId"
      :selected-item="selectedItem"
      :is-new-caps-man="isNewCapsMan"
      @close-modal="resetModal"
    />
  </b-card>
</template>

<script>

import {
  BCard, BCardBody, BSpinner, BDropdown, BDropdownItem, BFormCheckbox, BCol, BRow, BTabs, BTab,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import IndexPagesMixin from '@/mixins/IndexPages.vue'

import { VueGoodTable } from 'vue-good-table'
import TableMobileSolo from '@/components/TableMobileSolo.vue'
import axios from '../../../axios-resolver'
import EditModal from './EditModal.vue'

export default {
  components: {
    BCardBody,
    VueGoodTable,
    BCard,
    BSpinner,
    BDropdown,
    BCol,
    BRow,
    BDropdownItem,
    BFormCheckbox,
    EditModal,
    BTabs,
    BTab,
    TableMobileSolo,
  },
  mixins: [
    IndexPagesMixin,
  ],
  props: {
    siteId: {
      required: true,
      type: String,
    },
    newCapsman: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      isLoading: true,
      isItemSelected: false,
      selectedItem: null,
      items: [],
      search: '',
      searchFields: '',
      orderBy: '',
      sortedBy: '',

      activeTab: 'Wi-Fi 5',

      pagination: {
        total: 0,
        per_page: 10,
        last_page: 0,
        current_page: 1,
      },
      fieldLabelsSelected: {
        name: {
          label: 'Interface Name',
          selected: true,
        },
        comment: {
          label: 'Comment',
          selected: true,
        },
        model: {
          label: 'Model',
          selected: true,
        },
        serial: {
          label: 'Serial',
          selected: true,
        },
        ssid: {
          label: 'SSID',
          selected: true,
        },
        network: {
          label: 'Network',
          selected: true,
        },
        channel: {
          label: 'Channel Selection',
          selected: true,
        },
        current_channel: {
          label: 'Current Channel',
          selected: true,
        },
        master: {
          label: 'Master Interface',
          selected: true,
        },
        current_state: {
          label: 'Status',
          selected: true,
        },
        enabled: {
          label: 'Enabled',
          selected: true,
        },
      },
      sortTimeout: null,
      pageSizeOptions: [25, 50, 75, 100],
      fields: [
        {
          field: 'id',
          sortable: false,
          hidden: true,
        },
        {
          field: 'name',
          label: 'Interface Name',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Interface Name',
            filterValue: '',
          },
        },
        {
          field: 'comment',
          label: 'Comment',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Comment',
            filterValue: '',
          },
        },
        {
          field: 'model',
          label: 'Model',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Model',
            filterValue: '',
          },
        },
        {
          field: 'serial',
          label: 'Serial',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Serial',
            filterValue: '',
          },
        },
        {
          field: 'ssid',
          label: 'SSID',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'SSID',
            filterValue: '',
          },
        },
        {
          field: 'network',
          label: 'Network',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Network',
            filterValue: '',
          },
        },
        {
          field: 'channel',
          label: 'Channel Selection',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Channel Selection',
            filterValue: '',
          },
        },
        {
          field: 'channelList',
          sortable: false,
          hidden: true,
          filterOptions: {
            enabled: true,
            filterValue: '',
          },
        },
        {
          field: 'current_channel',
          label: 'Current Channel',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Current Channel',
            filterValue: '',
          },
        },
        {
          field: 'master',
          label: 'Master',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Master',
            filterValue: '',
          },
        },
        {
          field: 'master_interface',
          label: 'Master Interface',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Master Interface',
            filterValue: '',
          },
        },
        {
          field: 'current_state',
          label: 'Status',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Status',
            filterValue: '',
          },
        },
        {
          field: 'enabled',
          label: 'Enabled',
          sortable: false,
        },
        {
          field: 'actions',
          label: 'Actions',
          sortable: false,
          thClass: 'action-th-width',

        },
      ],

      isNewCapsMan: false,
    }
  },
  watch: {
    activeTab(newValue) {
      this.isNewCapsMan = newValue
      this.isLoading = true
      this.search = ''
      this.searchFields = ''
      this.orderBy = ''
      this.sortedBy = ''

      this.fields = this.fields.map(item => {
        if (item.field === 'current_state') {
          return {
            ...item,
            hidden: newValue,
          }
        }
        return item
      })

      this.fieldLabelsSelected = {
        ...this.fieldLabelsSelected,
        current_state: {
          ...this.fieldLabelsSelected.current_state,
          selected: !newValue,
        },
      }
      this.resetTable()
      this.fetchTable()
    },
  },
  created() {
    this.activeTab = !this.newCapsman ? 'Wi-Fi 5' : 'Wi-Fi 6+'
    this.isNewCapsMan = !!this.newCapsman
  },
  methods: {
    resetTable() {
      this.orderBy = null
      this.sortedBy = null
    },
    async fetchTable() {
      try {
        // const sortOptionURL = this.orderBy && this.sortedBy ? `?orderBy=${this.orderBy}&sortedBy=${this.sortedBy}` : ''
        const searchURL = this.search ? `?search=${this.search}&searchFields=${this.searchFields}&searchJoin=and` : ''
        const { data } = await axios.get(`/site/${this.siteId}/wifi/${(this.isNewCapsMan || this.newCapsman) ? 'new-' : ''}access-point/index${searchURL}`)
        this.items = data.data.map(el => ({
          ...el,
          enabled: !el.disabled,
        }))
        this.isLoading = false
      } catch (error) {
        console.warn(error)
      }
    },
    onColumnFilter(prop) {
      const filterParams = prop.columnFilters

      let search = ''
      let searchFields = ''

      Object.keys(filterParams).forEach(key => {
        if (filterParams[key]) {
          search += `${key}:${filterParams[key]};`
          if (key === 'created_at' || key === 'activation_at' || key === 'renewal_at' || key === 'expiry_at') {
            searchFields += `${key}:like;`
          } else {
            searchFields += `${key};`
          }
        }
      })
      this.search = search
      this.searchFields = searchFields

      setTimeout(() => {
        this.fetchTable()
      }, 1000)
    },
    onSortChange(params) {
      this.orderBy = params[0].field
      this.sortedBy = params[0].type
      if (params[0].type) {
        setTimeout(() => {
          this.fetchTable()
        }, 1000)
      }
    },
    changeColumns(field) {
      this.fields = this.fields.map(item => {
        if (item.field === field) {
          return {
            ...item,
            hidden: !item.hidden,
          }
        }
        return item
      })

      this.fieldLabelsSelected = {
        ...this.fieldLabelsSelected,
        [field]: {
          ...this.fieldLabelsSelected[field],
          selected: !this.fieldLabelsSelected[field].selected,
        },
      }
      this.$refs.dropdown.show()
    },
    openEditModal(itemToEdit, fromMobile) {
      this.isItemSelected = true
      this.selectedItem = itemToEdit

      if (fromMobile) {
        this.$bvModal.show('access-point-modal')
      }
    },
    resetModal() {
      this.isItemSelected = false
      this.selectedItem = null
    },
    async changeStatus(item) {
      try {
        if (item.enabled) {
          await axios.put(`/site/${this.siteId}/wifi/${this.isNewCapsMan ? 'new-' : ''}access-point/disable`, {
            ids: [item.id],
          })
        } else {
          await axios.put(`/site/${this.siteId}/wifi/${this.isNewCapsMan ? 'new-' : ''}access-point/enable`, {
            ids: [item.id],
          })
        }
        this.fetchTable()

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'BellIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.warn('error', error)
      }
    },
  },
}
</script>

<style lang="scss">
</style>
